import React, { PureComponent } from 'react';
import { partial } from 'lodash';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import Button from 'components/clickables/Button';
import Text from 'components/Text';

import {
  LAST_MESSAGE_PILL,
  PREFILL_PILL_IDS,
  SET_UP_CALL_PILL,
} from '../../../hiring/constants';

export default class ApplicantMessengerPrefillPills extends PureComponent {
  static propTypes = {
    hasApplicantPhone: PropTypes.bool.isRequired,
    hasLastMessagePill: PropTypes.bool,
    onPrefillPillClick: PropTypes.func.isRequired,
  };

  renderPrefillPills() {
    return PREFILL_PILL_IDS.map((id, key) => {
      if (id === SET_UP_CALL_PILL && !this.props.hasApplicantPhone) {
        return null;
      }

      if (id === LAST_MESSAGE_PILL && !this.props.hasLastMessagePill) {
        return null;
      }

      return (
        <Box inlineBlock key={`${key}-${id}`} mr8 mv={2}>
          <Button
            i18n={`hiring.application_messaging.prefill_pills.${id}.title`}
            onClick={partial(this.props.onPrefillPillClick, id)}
            pill
            size="mini"
            theme="secondary-blue"
          />
        </Box>
      );
    });
  }

  render() {
    return (
      <Box basis={25} grow={0} shrink={0} paxs spacebetween vcenter>
        {!this.props.hasLastMessagePill && (
          <Box mrxxs>
            <Text
              fs12
              i18n="hiring.application_messaging.prefill_pills.try_template"
            />
          </Box>
        )}
        <Box>{this.renderPrefillPills()}</Box>
      </Box>
    );
  }
}
